<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" :width="width" :height="height"><g stroke-linecap="round" stroke-linejoin="round" :stroke-width="strokewidth" :fill="_secondaryfill" :stroke="_secondaryfill"><line x1="21" y1="8" x2="44" y2="8" fill="none" :stroke="fill"></line> <line x1="21" y1="24" x2="44" y2="24" fill="none"></line> <line x1="21" y1="40" x2="44" y2="40" fill="none" :stroke="fill"></line> <rect x="4" y="3" width="10" height="10" fill="none" :stroke="fill"></rect> <rect x="4" y="35" width="10" height="10" fill="none" :stroke="fill"></rect> <polyline points="4 24 8 28 15 19" fill="none"></polyline></g></svg></template>

<script>
export default {
	props: {
		width: {
			type: [Number, String],
			default: "100%"
		},
		height: {
			type: [Number, String],
			default: "100%"
		},
		strokewidth: {
			type: [Number, String],
			default: 1
		},
		fill: {
			type: String,
			default: "currentColor"
		},
		secondaryfill: {
			type: String
		}
	},
	computed: {
		_secondaryfill: function () {
			return this.secondaryfill || this.fill
		}
	}
}
</script>